import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../auth/hooks/useAuth";
import { updateUserQuestion } from "../../../api/userQuestion";

export const useUpdateUserQuestion = (id: string) => {
    const { csrfToken } = useAuth();

    const mutation = useMutation({
        mutationFn: async (params: { title: string }) => {
            await updateUserQuestion(id, params.title, csrfToken);
        },
    });

    return { updateUserQuestion: mutation };
};
